import Vue from 'vue';
export default new Vue();//中央事件总线
